import React from 'react';

// Preview instan (client-side, tanpa render ffmpeg) — perkiraan crop 9:16 + status
// watermark per platform tujuan. Bukan hasil pixel-perfect, cuma panduan visual cepat
// sebelum submit. Aturan watermark di sini HARUS selaras dengan worker.js/needsTiktok().
const PLATFORM_META = {
  youtube: { label: 'YouTube', icon: '▶', watermark: true },
  instagram: { label: 'Instagram', icon: '📸', watermark: true },
  tiktok: { label: 'TikTok', icon: '🎵', watermark: false },
};

export default function PlatformPreview({ platforms, videoUrl, thumbnailUrl }) {
  const active = [];
  if (platforms === 'youtube' || platforms === 'both' || platforms === 'all') active.push('youtube');
  if (platforms === 'instagram' || platforms === 'both' || platforms === 'all') active.push('instagram');
  if (platforms === 'tiktok' || platforms === 'all') active.push('tiktok');

  if (active.length === 0 || (!videoUrl && !thumbnailUrl)) return null;

  return (
    <div style={{ marginBottom: 14 }}>
      <div style={{ fontSize: 13, color: '#f1f5f9', fontWeight: 600, marginBottom: 4 }}>👁 Preview per Channel</div>
      <div style={{ fontSize: 11, color: '#64748b', marginBottom: 8 }}>Perkiraan crop &amp; watermark — bukan hasil render final.</div>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
        {active.map(p => {
          const meta = PLATFORM_META[p];
          return (
            <div key={p} style={{ width: 104 }}>
              <div style={{ position: 'relative', width: 104, height: 185, borderRadius: 8, overflow: 'hidden', background: '#000', border: '1px solid rgba(255,255,255,0.18)' }}>
                {videoUrl ? (
                  <video src={videoUrl} muted style={{ position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)', height: '100%', width: 'auto', maxWidth: 'none' }} />
                ) : (
                  <img src={thumbnailUrl} alt="" style={{ position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)', height: '100%', width: 'auto', maxWidth: 'none' }} />
                )}
                <div style={{ position: 'absolute', inset: 0, border: '2px dashed rgba(255,87,34,0.85)', pointerEvents: 'none' }} />
                <div title={meta.watermark ? 'Watermark aktif' : 'Tanpa watermark'}
                  style={{ position: 'absolute', top: 4, right: 4, fontSize: 10, fontWeight: 700, padding: '2px 5px', borderRadius: 5, background: meta.watermark ? 'rgba(16,185,129,0.85)' : 'rgba(239,68,68,0.85)', color: '#fff' }}>
                  {meta.watermark ? '🖼️' : '🚫'}
                </div>
              </div>
              <div style={{ fontSize: 10.5, color: '#94a3b8', textAlign: 'center', marginTop: 4 }}>
                {meta.icon} {meta.label}<br />{meta.watermark ? 'dgn watermark' : 'tanpa watermark'}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
